import { Component, Injector, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MaterialModule } from 'jk-service';
import { PageKind, UiModeType, } from 'jk-service';
import { UtymcService, templateUrlConfigUty } from '../_service_uty';
import { jkSingleComponent, JkaggridComponent } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';
import { UtymcEditComponent } from '../utymc-edit/utymc-edit.component';


@Component({
  selector: 'app-utyji05',
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    JkaggridComponent,
  ],
  templateUrl: templateUrlConfigUty.utyji05,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Utyji05Component extends jkSingleComponent implements OnInit {
  override _programId = 'utyji05';
  constructor() {
    super();
    this.srv = new UtymcService();
    this.uiMode = UiModeType.dialog;
    this.title = 'IP/電腦設定記錄';
    this.gridInitOpt = { programId: this.programId, sortField: 'MC002', sort: 'asc', defaultSort: null, pageKind: this.pageKind };
    this.qbeConfig.addField = 'MC003,MC004,MC009,MC010,MC011';
    this.qbeConfig.addWhere = '';
    this.masterEditPage = UtymcEditComponent;


    this.constructorInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    //this.checkAllInit(this); // 這行要放在 ngAfterViewInit 最後  ###
    await (this.srv as UtymcService).doRefresh();

  }

}
